export default __webpack_public_path__ + "621b1150990f68106a6591fb3e0d9853.webp";